var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181 101",
    width: 181,
    height: 101,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "success-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { opacity: 0.6;fill: #4afaac } \n\t\t.shp1 { fill: #01ce6e } \n\t\t.shp2 { fill: #ffffff } \n\t\t.shp3 { fill: #cbcbcb } \n\t\t.shp4 { fill: #4afaac } \n\t\t.shp5 { fill: #f7f0eb } \n\t\t.shp6 { fill: #fffbf5 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_9",
    className: "shp0",
    d: "M116.86 0.55L171.69 74.09L81.44 85.17L116.86 0.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8",
    className: "shp1",
    d: "M89.1 17.25L180.45 25.75L128.25 100.22L89.1 17.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_39-2",
    className: "shp2",
    d: "M3 24L134 24C135.66 24 137 25.34 137 27L137 86C137 87.66 135.66 89 134 89L3 89C1.34 89 0 87.66 0 86L0 27C0 25.34 1.34 24 3 24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40",
    className: "shp3",
    d: "M68.53 38L93.53 38C94.63 38 95.53 38.89 95.53 40L95.53 40C95.53 41.11 94.63 42 93.53 42L68.53 42C67.42 42 66.53 41.11 66.53 40L66.53 40C66.53 38.89 67.42 38 68.53 38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46",
    className: "shp3",
    d: "M68.53 70L93.53 70C94.63 70 95.53 70.89 95.53 72L95.53 72C95.53 73.11 94.63 74 93.53 74L68.53 74C67.42 74 66.53 73.11 66.53 72L66.53 72C66.53 70.89 67.42 70 68.53 70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    className: "shp3",
    d: "M68.53 62L78.53 62C79.63 62 80.53 62.89 80.53 64L80.53 64C80.53 65.11 79.63 66 78.53 66L68.53 66C67.42 66 66.53 65.11 66.53 64L66.53 64C66.53 62.89 67.42 62 68.53 62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_44",
    className: "shp3",
    d: "M86.53 62L96.53 62C97.63 62 98.53 62.89 98.53 64L98.53 64C98.53 65.11 97.63 66 96.53 66L86.53 66C85.42 66 84.53 65.11 84.53 64L84.53 64C84.53 62.89 85.42 62 86.53 62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45",
    className: "shp3",
    d: "M104.53 62L114.53 62C115.63 62 116.53 62.89 116.53 64L116.53 64C116.53 65.11 115.63 66 114.53 66L104.53 66C103.42 66 102.53 65.11 102.53 64L102.53 64C102.53 62.89 103.42 62 104.53 62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42",
    className: "shp3",
    d: "M68.53 54L108.53 54C109.63 54 110.53 54.89 110.53 56L110.53 56C110.53 57.11 109.63 58 108.53 58L68.53 58C67.42 58 66.53 57.11 66.53 56L66.53 56C66.53 54.89 67.42 54 68.53 54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41",
    className: "shp3",
    d: "M68.53 46L116.53 46C117.63 46 118.53 46.89 118.53 48L118.53 48C118.53 49.11 117.63 50 116.53 50L68.53 50C67.42 50 66.53 49.11 66.53 48L66.53 48C66.53 46.89 67.42 46 68.53 46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    className: "shp1",
    d: "M62.9 56.36L57.82 50.72L58.62 43.16L51.19 41.59L47.39 35L40.45 38.1L39.51 56.36L40.45 74.62L47.39 77.72L51.18 71.13L58.61 69.56L57.81 62L62.9 56.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    className: "shp4",
    d: "M33.51 35L29.72 41.59L22.29 43.16L23.09 50.72L18 56.36L23.08 62.01L22.28 69.56L29.72 71.13L33.51 77.72L40.45 74.62L40.45 38.1L33.51 35Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    className: "shp5",
    d: "M49.86 51.44L47.9 49.69L40.45 58.03L39.51 60.11L40.45 61.99L49.86 51.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    className: "shp6",
    d: "M32.63 54.38L30.76 56.24L38.59 64.07L40.45 61.99L40.45 58.04L38.48 60.24L32.63 54.38Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e7ec68a9.svg";
export { ForwardRef as ReactComponent };